"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const AuthProvider_1 = require("src/providers/AuthProvider");
const useGeneralHook_1 = require("core/components/useGeneralHook");
const react_router_dom_1 = require("react-router-dom");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const BankAttributes_1 = tslib_1.__importDefault(require("./BankAttributes"));
const BreadCrumb_1 = tslib_1.__importDefault(require("core/components/BreadCrumb"));
const useBank_1 = tslib_1.__importDefault(require("../hooks/useBank"));
const breadCrumb = (translate, id) => {
    const addOrEdit = id ? translate('menu_update', 'განახლება') : translate('menu_add', 'დამატება');
    return [
        { text: translate('menu_references_banks', 'ცნობარები - ბანკი'),
            link: '/references/banks' },
        { text: addOrEdit, link: '/' }
    ];
};
const AddOrEditBanks = () => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const params = (0, react_router_dom_1.useParams)();
    const auth = (0, AuthProvider_1.useAuth)();
    const bankId = params.id;
    const permissions = auth.state.data.user?.permissions || {};
    const hook = (0, useBank_1.default)({ bankId: bankId });
    const title = `Erp - ${bankId ? 'განახლება' : 'დამატება'} -  ბანკი`;
    (0, useGeneralHook_1.useGeneralHook)({ title, loading: hook.state.isFetching });
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'content  d-flex flex-column flex-column-fluid', children: [(0, jsx_runtime_1.jsx)(BreadCrumb_1.default, { path: breadCrumb(translate, bankId) }), (0, jsx_runtime_1.jsx)("div", { className: 'd-flex flex-column-fluid', children: (0, jsx_runtime_1.jsx)("div", { className: 'container', children: (0, jsx_runtime_1.jsxs)("div", { className: 'card card-custom', children: [(0, jsx_runtime_1.jsx)("div", { className: 'card-header', children: (0, jsx_runtime_1.jsx)("div", { className: 'card-title', children: (0, jsx_runtime_1.jsxs)("h3", { className: 'card-label', children: [" ", translate('menu_bank', 'ბანკების'), " ", bankId ? translate('menu_update', 'განახლება') : translate('menu_add', 'დამატება')] }) }) }), (0, jsx_runtime_1.jsx)(BankAttributes_1.default, { bankId: bankId, permissions: permissions, hook: hook })] }) }) })] }));
};
exports.default = AddOrEditBanks;
